<template>
  <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-show="open" :class="{show: open}">
    <div class="cstm-modal">
      <div class="header">
        <h3>Edit Assigned Students</h3>
        <button @click="closeModal" class="close-modal">&times;</button>
      </div>
        
      <div class="p-4 modal-content">
        <div class="flex flex-1 flex-wrap">
          <div class="w-full p-1">
            <v-select 
              class="w-full"
              multiple
              placeholder="Search and Add Students"
              v-model="selected_students_list"
              :options="students_list"
              label="full_name"
              :filterable="false"
              :clearable="false"
              @search="onStudentSearch"
             
            > 
               <template v-slot:selected-option="students_list">
                  <img
                    v-if="students_list.picture"
                    class="person-img rounded-full"
                    :src="students_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ students_list.first_name }}
                  {{ students_list.last_name }}
                </template>
            <template v-slot:option="students_list">
                  <img
                    v-if="students_list.picture"
                    class="person-img rounded-full"
                    :src="students_list.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  {{ students_list.first_name }}
                  {{ students_list.last_name }}
                </template>
            </v-select>
          </div>
          <div class="flex flex-1 flex-col">
            <vs-table 
              class="w-full cstm_vuexy_table"
              :data="selected_students_list"
            >
              <template slot="thead">
                <vs-th></vs-th>
                <vs-th>
                  Name
                </vs-th>
                <vs-th>
                  Email
                </vs-th>
                <vs-th>
                  Phone Number
                </vs-th>
                <vs-th>
                  User Type
                </vs-th>
                <vs-th>
                  Root User
                </vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].picture" style="width: 40px">
                    <img style="width: 20px; height: 20px;" :src="data[indextr].picture || 'http://cx-lms-api-dev.track-progress.com/staticAsset/emoticons/user_image.png'" class="rounded-full shadow-md block">
                  </vs-td>
                  <vs-td :data="data[indextr].full_name">{{ data[indextr].full_name }}</vs-td>
                  <vs-td :data="data[indextr].email">{{ data[indextr].email }}</vs-td>
                  <vs-td :data="data[indextr].phone">{{ data[indextr].phone }}</vs-td>
                  <vs-td :data="data[indextr].user_type">{{ data[indextr].user_type }}</vs-td>
                  <vs-td :data="data[indextr].root_user_name">{{ data[indextr].root_user_name }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>

        <div class="flex flex-1 justify-end mt-8">
          <vs-button @click="createNewClass">Save</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import { 
  searchStudentList,
  createClass
} from '@/api/classes'

export default {
  name: 'AssignedStudentsEditModal',
  props: ['open', 'basic_details', 'id_to_edit'],
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      uploadedFiles: [],
      files_info: [],
      customer_id: null,
      user_id: null,
      class_name: '',
      class_capacity: '',
      term: '',
      class_start_date: null,
      class_end_date: null,
      description: '',
      holidays: [],
      holiday_list: [],
      room: null,
      teachers_list: [],
      selected_teachers_list: [],
      class_teacher: null,
      students_list: [],
      selected_students_list: [],
      mode: 'Edit'
    }
  },
  created () {
    console.log('teacher')
    this.customer_id = localStorage.getItem('customer_id')
    this.user_id = JSON.parse(localStorage.getItem('userInfo')).id
  },
  watch: {
    basic_details:{
      deep:true,
      immediate:true,
      handler () {
        console.log(this.basic_details)
        if (this.basic_details) {
          console.log('hi')
          this.prepareForEdit()

        }
      }
    }
  },
  methods: {
    closeModal () {
      this.uploadedFiles = []
      this.class_name = ''
      this.class_capacity = ''
      this.term = ''
      this.class_start_date = null
      this.class_end_date = null
      this.description = ''
      this.holidays = []
      this.room = null
      this.teachers_list = []
      this.selected_teachers_list = []
      this.class_teacher = null
      this.students_list = []
      this.selected_students_list = []
      this.files_info = []

      this.$emit('close', false)
    },
    getFileId (file_id) {
      this.uploadedFiles.push(file_id)
    },
    deleteUploadedFile (index) {
      this.uploadedFiles.splice(index, 1)
    },
    async onStudentSearch (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.searchStudent(loading, search, this)
      }
    },
    // eslint-disable-next-line no-undef
    searchStudent: _.debounce(async (loading, search, vm) => {
      const customer_id = vm.$store.getters.customerId

      try {
        // Fetch the response from search query
        const response = await searchStudentList(customer_id, { name: search })

        vm.students_list = response.data.data.client_list.map(user => { 
          return {
            ...user,
            full_name: `${user.first_name} ${user.middle_name} ${user.last_name}` 
          }
        })
        loading(false)
      } catch (e) {
        console.log(e)
      }
    }, 350),
    deselectedTeacher (option) {
      const isClassTeacher = option.id === this.class_teacher
      if (isClassTeacher) {
        this.class_teacher = null
      }
    },
    async createNewClass () {
      const payload = {
        customer_id: this.customer_id,
        name: this.class_name,
        capacity: this.class_capacity,
        term: this.term,
        start_date: this.class_start_date,
        end_date: this.class_end_date,
        description: this.description,
        holiday_id: this.holidays,
        class_teacher_id: this.class_teacher,
        file_id: this.uploadedFiles[0],
        asset_id: this.room,
        userArray: []
      }

      this.selected_teachers_list.map(teacher => {
        payload.userArray.push({ user_id: teacher.id, user_type: 1 })
      })

      this.selected_students_list.map(student => {
        payload.userArray.push({ user_id: student.id, user_type: 2 })
      })

      if (this.mode === 'Edit') {
        Object.assign(payload, { class_id:  this.id_to_edit })
      }

      if (this.class_name) {
        try {
          const response = await createClass(payload)

          if (this.mode === 'Edit') {
            this.$emit('on_data_updated', response.data.data.class)
            this.showSuccessMessage('Success', 'Class updated successfully', 'success')
          } else {
            this.$emit('on_data_added', response.data.data.class)
            this.showSuccessMessage('Success', 'Class created successfully', 'success')
          }

          this.closeModal()
        } catch (e) {
          this.showSuccessMessage('Error', e.data.message, 'danger')
          this.closeModal()
        }
      } else {
        this.showSuccessMessage('Warning', 'Class Name is required', 'warning')
      }
    },
    async prepareForEdit () {
      const { 
        name, 
        start_date, 
        end_date, 
        term, 
        holiday, 
        capacity, 
        description, 
        asset_id,
        student,
        teacher,
        class_teacher_details,
        file 
      } = this.basic_details

      console.log(this.basic_details)
      
      this.class_name = name
      this.class_start_date = start_date
      this.class_end_date = end_date
      this.term = term
      this.class_capacity = capacity
      this.description = description
      this.room = asset_id
      this.class_teacher = class_teacher_details.id

      if (file) {
        this.uploadedFiles.push(file.files_id)
        this.files_info.push(file)
      }

      this.selected_teachers_list = teacher.teacher_details.map(item => {
        return {
          id: item.id,
          first_name: item.first_name,
          middle_name: item.middle_name,
          last_name: item.last_name,
          email: item.email,
          phone: item.phone,
          role_name: item.role_name,
          picture: item.picture,
          full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
        }
      })

      this.selected_students_list = student.student_details.map(item => {
        return {
          ...item,
          full_name: `${item.first_name} ${item.middle_name} ${item.last_name}`
        }
      })

      holiday.map(item => {
        this.holidays.push(item.id)
      })
    }
  }
}
</script>

<style scoped>
  .loader {
    text-align: center;
    color: #bbbbbb;
  }
</style>
<style>
.class_setting_collapse .vs-collapse-item.open-item .vs-collapse-item--content {
  overflow: unset;
}
</style>